export default "__VITE_ASSET__2e53a071__"